module.exports = __webpack_public_path__ + "img/4.99860a71.png";